// src/helpers/dates/parseDate.ts
export function parseDate (value) {
  if (value === null || value === undefined) {
    return null
  }

  if (value instanceof Date) {
    if (isNaN(value.getTime())) {
      return null
    }
    return value
  }

  const fromEpoch = (n) => {
    if (!isFinite(n)) {
      return null
    }

    // Heuristic: treat 10-digit seconds as seconds, 13-digit as ms
    // 1e12 ms ≈ 2001-09-09; anything smaller is probably seconds.
    const ms = n < 1e12 ? n * 1000 : n

    const d = new Date(ms)
    if (isNaN(d.getTime())) {
      return null
    }
    return d
  }

  if (typeof value === 'number') {
    return fromEpoch(value)
  }

  if (typeof value === 'string') {
    const s = value.trim()
    if (s === '') {
      return null
    }

    // Numeric epoch string
    if (/^\d+$/.test(s)) {
      return fromEpoch(Number(s))
    }

    // ISO (or similar) string
    const d = new Date(s)
    if (isNaN(d.getTime())) {
      return null
    }
    return d
  }

  // Mongo Extended JSON: { $date: "..." } or { $date: 123 } or { $date: { $numberLong: "..." } }
  if (typeof value === 'object') {
    const v = value

    if (v && v.$date !== undefined) {
      const inner = v.$date
      if (inner && typeof inner === 'object' && inner.$numberLong !== undefined) {
        return parseDate(inner.$numberLong)
      }
      return parseDate(inner)
    }
  }

  return null
}
